import styled from 'styled-components/macro';
import Split from 'react-split';

import * as colors from 'components/common/colorConstants';

export const Section = styled.div`
  height: 100%;
  display: ${(props) => (props.hide ? 'none' : 'block')};
  position: relative;
  min-width: 385px;
  border-right: ${(props) => (props.hide ? '0' : `var(--panel-border-width, 0) solid ${colors.lightGray21}`)};

  :nth-of-type(3) {
    border-left: var(--section-legacy-border, 1px) solid ${colors.lightGray21};
  }
`;

export const SplitPages = styled(Split)`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;

  > .gutter {
    opacity: 0;
    cursor: col-resize;
    position: relative;
    z-index: 7;
    margin-right: -4px;
    pointer-events: ${(props) => props.$hidegutter && 'none'};

    /* if showing actions section hide left divider */
    :nth-of-type(2) {
      display: ${(props) => (props.$showtools ? 'none' : 'block')};
    }

    /* if hiding actions section hide right divider */
    :nth-of-type(4) {
      display: ${(props) => (props.$showtools ? 'block' : 'none')};
    }
  }
`;

export const BoxHolder = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-left: 60px;
`;
